<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ query.categoryName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增计量</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">批量删除</el-button>

          <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn" size="small" v-preventReClick :disabled="multiple" @click="handlePrint">数据打印</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <template v-for="(item, index) in tableColumn">
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" :min-width="item.minWidth" v-if="item.type == 'ware'">
            <template slot-scope="scope">
              <template v-if="item.formatter">
                <div>
                  {{ item.formatter(scope.row[item.rowData.data1]) }}
                </div>
                <div>
                  {{ item.formatter(scope.row[item.rowData.data2]) }}
                </div>
              </template>
              <template v-else>
                <div>
                  {{ scope.row[item.rowData.data1] }}
                </div>
                <div>
                  {{ scope.row[item.rowData.data2] }}
                </div>
              </template>
            </template>
          </el-table-column>
          <!-- 日期 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'Date'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 时间 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'DateTime'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{h}:{i}:{s}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 普通列 -->
          <el-table-column v-else :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width"></el-table-column>
        </template>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="planState" label="计量状态" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="color:#E8873D">
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 1" style="color:#6EA204">
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 2" style="color:#CE1126">
              {{ scope.row.stateName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="CanEdit(scope.row)" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-else-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button v-if="
                query.category != 0 &&
                  tableAcl.indexOf('Remove') != -1 &&
                  scope.row.state == 0
              " type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetMeterings, RemoveMeterings } from "@/api";
export default {
  mixins: [GetDataMixin],
  components: {},
  /** 定义属性 */
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      tableColumn: [
        {
          type: "ware",
          label: "计量名称",
          rowData: {
            data1: "name",
            data2: "no",
          },
          width: "140",
        },
        {
          label: "计量单位",
          prop: "unitName",
          width: "120",
        },
        {
          label: "单位联系人",
          prop: "contactor",
          width: "120",
        },
        {
          label: "联系方式",
          prop: "phone",
          width: "120",
        },
        {
          label: "计量费用",
          prop: "totalAmount",
          width: "100",
          formatter: this.toDecimal4,
        },
        {
          label: "计量工时(人/小时)",
          prop: "hour",
          width: "140",
          formatter: this.GSFomatter,
        },
        {
          label: "创建人",
          prop: "createdUserName",
          width: "120",
        },
        {
          type: "DateTime",
          label: "创建时间",
          prop: "createdTime",
          width: "140",
        },
        {
          label: "备注",
          prop: "remark",
          minWidth: "120",
          tooltip: true,
        },
      ],
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    refenceQuery () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
    },
    // 获取列表
    getData () {
      GetMeterings(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 查看信息
    handleInfo (row) {
      this.$router.push(
        "/metering-edit?formMode=0&id=" +
        row.id +
        "&category=" +
        this.query.category
      );
    },
    // 新建
    handleAdd () {
      this.$router.push("/metering-edit?formMode=1");
    },
    // 编辑
    handleUpdate (row) {
      this.$router.push("/metering-edit?formMode=2&id=" + row.id);
    },
    // 审批
    handleApprove (row) {
      this.$router.push("/metering-edit?formMode=3&id=" + row.id);
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveMeterings({ ids });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    /**
     * 打印
     */
    handlePrint () {
      if (this.multipleSelection.length != 1) {
        this.$my_message(`只能勾选一条数据打印`, "warning");
        this.$refs.multipleTable.clearSelection();
      } else {
        let planId = this.multipleSelection[0].id;
        this.RoutePushName("MeteringPrintPreview", {
          id: planId,
          title: "资产计量单",
        });
      }
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    DateTimeFomatter (val) {
      return this.parseTime(new Date(val), "{y}-{m}-{d}");
    },
    toDecimal4 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 4);
    },
    GSFomatter (row, column, cellValue, index) {
      return 1 + "/" + this.toDecimal(cellValue, 2);
    },
    CanEdit (row) {
      if (row.dutyUserId == this.userInfo.id) {
        // 是计量责任人
        if (row.state != 2) {
          // 计量状态不是已完成
          return (
            this.isAdmin ||
            this.userInfo.id == row.createdUser ||
            this.userInfo.id == row.dutyUserId
          );
        } else if (row.status == 0 && row.state == 2) {
          // 计量状态已完成 && 流程未通过
          return (
            this.isAdmin ||
            this.userInfo.id == row.createdUser ||
            this.userInfo.id == row.dutyUserId
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () { },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
